import axios from 'axios';
import { nodeCaUrl } from 'constant';

// Method for fetching user details.
const getCarriersApi = async (userData: any, token: any): Promise<any> => {
    try {
        // Send a GET request to the "/user-profile" endpoint with the provided token.
        return (await axios.post(nodeCaUrl + "/carrier-admin-list", userData, token)).data;
    } catch (error: any) {
        // Handle errors and reject the promise with the error.
        return Promise.reject(error);
    }
};

const createCarrierDbApi = async (userData: any, token: any): Promise<any> => {
    try {
        // Send a GET request to the "/user-profile" endpoint with the provided token.
        return (await axios.post(nodeCaUrl + "/carrier-database-create", userData, token)).data;
    } catch (error: any) {
        // Handle errors and reject the promise with the error.
        return Promise.reject(error);
    }
};

const carrierService = {
    getCarriersApi,
    createCarrierDbApi
};

export default carrierService;